export default {
  title: 'AI floor plan generator: convert 2D to 3D | Getfloorplan',
  description: 'Download a 2D floor plan to get great 3D renderings with furniture and a virtual tour.',
  keywords: '3d floor plan cost, floor plan rendering, create 3d floor plans, 3d floor plan, 3d floor plan small house, home floor plan builder, 3d floorplan maker, convert floorplan, floorplan converter',
  hostname: 'https://getfloorplan.com',
};
